import { categoryToType } from './constants';

export const mapMessagesToDeviceInfos = (messages) => {
  return messages.filter(({ deviceInfo }) => deviceInfo && deviceInfo.length === 1)
    .map(({ deviceInfo, lat, lon, mac }) => ({
      id: mac,
      name: deviceInfo[0].name,
      type: categoryToType[deviceInfo[0].category],
      isActive: deviceInfo[0].is_active,
      x: lat,
      y: lon,
    }));
};

export const reduceTagsToKeyValue = (tags, acc) => {
  return tags.reduce((acc, tag) => {
    acc[tag.id] = tag;
    return acc;
  }, acc);
};

export const mapDataToDoorInfos = (data) => {
  return data.map(d => ({
    name: d.name,
    x: d.xpos,
    y: d.ypos
  }));
};

export const mapDataToGatewayInfos = (data) => {
  return data.map(g => ({
    name: g.name,
    x: g.lat,
    y: g.lon,
  }));
};

export const applyFilters = (deviceInfosMap, visibleTags, searchQuery) => {
  searchQuery = searchQuery.trim().toLowerCase();
  return Object.values(deviceInfosMap).filter(d => {
    return visibleTags.includes(d.type) && (
      searchQuery === '' ||
      d.name.toLowerCase().includes(searchQuery)
    );
  });
};
